import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { GroupAdBlock } from '../blocks.types'

export const CarouselGroupAdBlockFragment: BlockFragment = {
  name: 'carouselGroupAd',
  fragment: gql`
    fragment carouselGroupAd on CarouselGroupAd {
      id
      blockType
      ads {
        id
        title
        description
        image {
          url
          alt
        }
        link
        linkText
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on CarouselGroupAd {
      id
      blockType
      ads {
        id
        title
        description
        image {
          url
          alt
        }
        link
        linkText
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const CarouselGroupAdBlockType = 'carouselGroupAd'

export interface CarouselGroupAdBlock extends GroupAdBlock {
  blockType: typeof CarouselGroupAdBlockType
  ads: {
    id: string
    title: string
    description: string
    image: {
      url: string
      alt: string
    }
    link: string
    linkText: string
  }[]
}
